import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        disconnect: 'logout',
        title: 'Looking for a BMS',
        ble: 'Bluetooth',
        wifi: 'Wifi'
    },
    fr:{
        disconnect: 'Se déconnecter',
        title: 'Recherche de BMS',
        ble: 'Bluetooth',
        wifi: 'Wifi'
    }
})

export default strings